import { Constantes } from './constantes';
// Cargamos el import del servicio de traducción de la librería
import {TranslateService} from 'ng2-translate';

export class TipologiaContenidoFormulario {
	// Alimentar los inputs
	Id: string;
	Nombre: string;
	Idiomas: Map<string, TipologiaContenidoIdiomaFormulario>;
	Tipo = '';
	Buscable= false;
	VisibleEnMapa= false;
	UbicarAnonimos= false;
	PantallaPrincipal= Number;
	MostrableEnDirectorioDeContenidos= false;
	VisibilidadPorDefecto = true;
	IconoRepresentacion = '';
	VisibilidadLabelMapa = '';
	VisibilidadIconoMapa = '';
	VisibilidadListaCOntenidosSeccion = '';
	anchorPoint: AnchorPoint;
	VisibilidadMenuLateral = false;
	VisibilidadListaContenidosWeb = true;
	TipoUbicacion = null;
	Activa = true;

	// Objeto de Breeze
	ENTIDAD: any;

	constructor(
		private translate: TranslateService,
		tipologia?) 
	{
		this.Nombre = '';
		this.Id = '';
		this.ENTIDAD = {};
		this.Tipo = '';
		this.Buscable = false;
		this.VisibleEnMapa = false;
		this.UbicarAnonimos = false;
		this.MostrableEnDirectorioDeContenidos = false;
		this.VisibilidadPorDefecto = true;
		this.IconoRepresentacion = '';
		this.Idiomas = new Map<string, TipologiaContenidoIdiomaFormulario>();
		this.VisibilidadLabelMapa = '';
		this.VisibilidadIconoMapa = '';
		this.VisibilidadListaCOntenidosSeccion = '';
		this.anchorPoint = new AnchorPoint();
		this.VisibilidadMenuLateral = false;
		this.VisibilidadListaContenidosWeb = true;
		this.TipoUbicacion = new TipoLocalizacion(this.translate);;
		this.Activa = true;
		

		if (tipologia) {

			this.ENTIDAD = tipologia;
			this.Id = tipologia.Id;
			this.Nombre = tipologia.Nombre;
			this.Tipo = tipologia.Tipo;
			this.Buscable = tipologia.Buscable;
			this.VisibleEnMapa = tipologia.VisibleEnMapa;
			this.UbicarAnonimos = tipologia.UbicarAnonimos;
			this.PantallaPrincipal = tipologia.PantallaPrincipal;
			this.MostrableEnDirectorioDeContenidos = tipologia.MostrableEnDirectorioDeContenidos;
			this.VisibilidadPorDefecto = tipologia.VisibilidadPorDefecto;
			this.IconoRepresentacion = tipologia.IconoRepresentacion;
			this.VisibilidadLabelMapa = tipologia.VisibilidadLabelMapa;
			this.VisibilidadIconoMapa = tipologia.VisibilidadIconoMapa;
			this.VisibilidadListaCOntenidosSeccion = tipologia.VisibilidadListaCOntenidosSeccion;
			this.anchorPoint = new AnchorPoint(tipologia.AnchorPoint);
			
			this.VisibilidadMenuLateral = tipologia.VisibilidadMenuLateral;
			this.VisibilidadListaContenidosWeb = tipologia.VisibilidadListaContenidosWeb;
			this.TipoUbicacion = new TipoLocalizacion(this.translate, tipologia.TipoUbicacion);
			this.Activa = tipologia.Activa;

			tipologia.IDIOMAS.forEach(element => {
				const aux = new TipologiaContenidoIdiomaFormulario(element);
				if (element.IDIOMA) {
					this.Idiomas.set(element.IDIOMA.Codigo, aux);
				}
			});
		}

	}
}

export class AnchorPoint {
	value: string;
	label: string;

	constructor(anchorValue?: string) {
		if (anchorValue) {
			this.value = anchorValue;
			this.label = anchorValue;
		}
		else{
			this.value = Constantes.bottom_right;
			this.label = Constantes.bottom_right;
		}
	 }
}

export class TipoLocalizacion {
	value: string;
	label: string;

	constructor(private translate: TranslateService, locationValue?: string) {
		if (locationValue) {
			this.value = locationValue;
			this.label = this.translate.instant('Formularios.' + locationValue);
		}
		else{
			this.value = 'ESTATICO';
			this.label = this.translate.instant('Formularios.' + 'ESTATICO');
		}

	}
}

export class TipologiaContenidoIdiomaFormulario {

	Codigo: string;
	Nombre: string;


	constructor(espacioIdioma?) {

		if (espacioIdioma && espacioIdioma.IDIOMA) {
			this.Codigo = espacioIdioma.IDIOMA.Codigo ? espacioIdioma.IDIOMA.Codigo : '';
			this.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/TipologiaContenidoFormulario.ts